import script from "./Payment.vue?vue&type=script&setup=true&lang=ts"
export * from "./Payment.vue?vue&type=script&setup=true&lang=ts"

import "./Payment.vue?vue&type=style&index=0&id=437b7147&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-437b7147"]])

export default __exports__